/* eslint-disable @typescript-eslint/naming-convention */
const sharedRoutes = {
  stopImpersonating: "/a/sessions/stop_impersonating",

  external: {
    support: "https://support.fullscript.com/",
    termsOfService: "https://fullscript.com/terms-of-service",
    privacyPolicy: "https://fullscript.com/privacy",
    accessibility: "https://fullscript.com/accessibility",
    californiaPrivacy: "https://fullscript.com/ccpa",
    autoshipHandout: "https://fs-marketing-files.s3.amazonaws.com/handouts/autoship-education.pdf",
    shippingPolicyWholesale:
      "https://support.fullscript.com/hc/en-us/articles/360047665712-Wholesale-shipping-policy",
    shippingPolicyRetail:
      "https://support.fullscript.com/hc/en-us/articles/360020978272-Patient-shipping-policy",
    refundPolicy: "https://support.fullscript.com/hc/en-us/articles/360020956252-Refunds-returns",
  },
} as const;

export { sharedRoutes };
